export abstract class AppConstants {
  static readonly app_build_number = 1; //Version for android app
  static readonly app_enable = false; //Enable app
  static readonly user_find_customer_max_days = 15;
  static readonly allow_lead_view_customer_details = false;
  static readonly allow_see_customer_number = false;
  static readonly allow_users_update_customer_name = false;
  static readonly allow_user_modify_step = false;
  static readonly customer_resume_based_on_steps_colors = false;
  static readonly campaign_id_for_finances = "campaign_id_for_finances";
  static readonly call_audit_required_per_month = 3;
}